import {
  SUBMIT_CONTACT,
  SUBMIT_CONTACT_FAILURE,
  SUBMIT_CONTACT_SUCCESS,
} from '../actions/contactActions';


const contact = (state = [], action) => {
  switch (action.type) {
    case SUBMIT_CONTACT:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case SUBMIT_CONTACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };

    case SUBMIT_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        step: "SENT",
        error: "",
      };

    default:
      return state;
  }
};

export default contact;




// WEBPACK FOOTER //
// ./src/reducers/contact.js